var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHexagon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 20.2993 0 H 10.7001 C 9.6642 -0.0001 8.6465 0.2685 7.7495 0.7787 C 6.8524 1.2889 6.1075 2.0227 5.5898 2.9064 L 0.7904 11.0936 C 0.2726 11.9771 0 12.9793 0 13.9994 C 0 15.0196 0.2726 16.0218 0.7904 16.9053 L 5.5898 25.0936 C 6.1077 25.9771 6.8527 26.7108 7.7497 27.221 C 8.6467 27.7311 9.6643 27.9998 10.7001 28 H 20.2993 C 21.3352 28.0001 22.3529 27.7315 23.25 27.2213 C 24.147 26.7111 24.8919 25.9773 25.4097 25.0936 L 30.2096 16.9053 C 30.7274 16.0218 31 15.0196 31 13.9994 C 31 12.9793 30.7274 11.9771 30.2096 11.0936 L 25.4114 2.9064 C 24.8933 2.0226 24.1481 1.2887 23.2508 0.7785 C 22.3534 0.2683 21.3355 -0.0002 20.2993 0 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagon);
export default __webpack_public_path__ + "static/media/hexagon.7f6ec9c12f2ae28250c25c34613fef59.svg";
export { ForwardRef as ReactComponent };